@if (buttonLink && buttonTargetType) {
  <mb-info-section
    infoType="primary"
    headline="{{ 'EVENT_REGISTRATION_SECTION.HEADLINE' | translate }}"
    text="{{ 'EVENT_REGISTRATION_SECTION.TEXT' | translate }}"
    buttonLabel="{{ 'EVENT_REGISTRATION_SECTION.BUTTON' | translate }}"
    [buttonLink]="buttonLink"
    [buttonTargetType]="buttonTargetType"
  ></mb-info-section>
}
